import { status_colors } from "./_constants"
import { Service } from "./_models";

export const getStatusColor = (service: Service): string => {
    for (const key in status_colors) {
        if (key === service.status) {
            return status_colors[key];
        }
    }
    return "transparent";
}
